/* All functions setting */

const menu = () => {
  const switcherMobile = document.querySelectorAll(".js-toggle");
  const megaMenu = document.querySelector(".js-mega-menu");
  const allLinkSubmenu = document.querySelectorAll(
    ".c-mega-menu__submenu-wrapper a"
  );

  if (switcherMobile) {
    const switcherTarget = document.querySelector(".js-header");
    switcherMobile.forEach((el) => {
      el.addEventListener("click", () => {
        switcherMobile.forEach((el2) => {
          el2.classList.toggle("is-active");
          // megaMenu.classList.toggle('is-active');
          megaMenu.classList.add("is-active");
        });
        // switcherTarget.classList.toggle('is-active');
        switcherTarget.classList.add("is-active");
      });
    });
  }

  /* After click submenu hide menu */
  if (allLinkSubmenu) {
    allLinkSubmenu.forEach((item) => {
      let attrHref = item.getAttribute("href");
      if (attrHref.charAt(0) == "#") {
        item.addEventListener("click", () => {
          let targetID = item.getAttribute("href");
          megaMenu.classList.remove("is-active");
          switcherMobile.forEach((it) => it.classList.remove("is-active"));
        });
      }
    });
  }

  /* Add class on hover (mega menu) */

  const itemsHover = document.querySelectorAll(".js-item-hover");
  const itemsHoverOnlyImages = document.querySelectorAll(
    ".js-item-hover-only-image"
  );
  const targetHoverImages = document.querySelectorAll(
    "picture.js-hover-target-it"
  );
  const itemsHoverArrow = document.querySelectorAll(".js-arrow-hovered");
  const targetHover = document.querySelectorAll(".js-hover-target-it");
  const submenuContainer = document.querySelector(".js-submenu-col");
  const allMode = megaMenu.getAttribute("data-allmode");
  const closeSubmenuView = document.querySelector(".js-close-submenu-view");
  const mobileHomeLinks = document.querySelectorAll(".js-mobile-home");

  function showSubmenuAction(e) {
    e.preventDefault();
    const targetItem = e.currentTarget.getAttribute("data-target");
    const modeItemClass =
      "c-mega-menu--mode-" + e.currentTarget.getAttribute("data-mode");
    itemsHover.forEach((it) => it.classList.remove("is-hover"));
    targetHover.forEach((it) => it.classList.remove("is-hover"));
    submenuContainer.classList.add("is-show");

    if (allMode) {
      const arr = allMode.split(",");
      arr.forEach((mode) =>
        megaMenu.classList.remove("c-mega-menu--mode-" + mode)
      );
    }

    megaMenu.classList.add(modeItemClass);

    e.currentTarget.classList.add("is-hover");

    targetHover.forEach((item) => {
      let itemMarker = item.getAttribute("data-marker");
      if (itemMarker === targetItem) item.classList.add("is-hover");
    });
  }

  if (itemsHover) {
    itemsHover.forEach((el) => {
      el.addEventListener("click", showSubmenuAction);
      if (window.innerWidth > 992)
        el.addEventListener("mouseover", showSubmenuAction, false);
    });
  }

  //hover only images
  if (itemsHoverOnlyImages) {
    itemsHoverOnlyImages.forEach((el) => {
      if (window.innerWidth > 992)
        el.addEventListener(
          "mouseover",
          function (e) {
            e.preventDefault();
            const targetItem = e.currentTarget.getAttribute("data-target");

            if (targetHoverImages) {
              targetHoverImages.forEach((it) =>
                it.classList.remove("is-hover")
              );
              targetHoverImages.forEach((item) => {
                let itemMarker = item.getAttribute("data-marker");
                if (itemMarker === targetItem) item.classList.add("is-hover");
              });
            }
          },
          false
        );
    });
  }

  if (closeSubmenuView) {
    closeSubmenuView.addEventListener("click", function (e) {
      submenuContainer.classList.remove("is-show");
      megaMenu.classList.remove("is-active");
      switcherMobile.forEach((it) => it.classList.remove("is-active"));
    });
  }

  //mobile change link to home page
  if (mobileHomeLinks) {
    mobileHomeLinks.forEach((link) => {
      if (window.innerWidth < 992) {
        let homeLink = link.getAttribute("data-home");
        if (homeLink) link.querySelector("a").setAttribute("href", homeLink);
      }
    });
  }

  /* Mega menu close open */

  const closeMegMenu = document.querySelector(".js-close-megamenu");
  if (closeMegMenu) {
    closeMegMenu.addEventListener("click", function () {
      megaMenu.classList.remove("is-active");
      switcherMobile.forEach((it) => it.classList.remove("is-active"));
    });
  }

  (function () {
    var doc = document.documentElement;
    var w = window;

    var prevScroll = w.scrollY || doc.scrollTop;
    var curScroll;
    var direction = 0;
    var prevDirection = 0;

    var header = document.getElementById("main-header-page");

    var checkScroll = function () {
      /*
       ** Find the direction of scroll
       ** 0 - initial, 1 - up, 2 - down
       */

      curScroll = w.scrollY || doc.scrollTop;
      if (curScroll > prevScroll) {
        //scrolled up
        direction = 2;
      } else if (curScroll < prevScroll) {
        //scrolled down
        direction = 1;
      }

      if (direction !== prevDirection) {
        toggleHeader(direction, curScroll);
      }

      if (curScroll < 10) {
        header.classList.remove("header-hidden");
        header.classList.remove("is-fixed");
      }

      prevScroll = curScroll;
    };

    var toggleHeader = function (direction, curScroll) {
      let startScroll = 2;
      if (direction === 2 && curScroll > startScroll) {
        header.classList.add("header-hidden");
        header.classList.remove("is-fixed");
        prevDirection = direction;
      } else if (direction === 1) {
        header.classList.remove("header-hidden");
        header.classList.add("is-fixed");
        prevDirection = direction;
      }
    };

    window.addEventListener("scroll", checkScroll);
  })();
};

/* play video */

const playVideo = () => {
  const parentMovie = document.querySelectorAll(".js-movie-wrap-single");
  if (parentMovie) {
    parentMovie.forEach((container) => {
      let videoBg = container.querySelector(".js-video-played");
      let btnStart = container.querySelector(".js-start-video");

      if (btnStart) {
        btnStart.addEventListener("click", (e) => {
          if(videoBg.paused) videoBg.play();
        });
      }

      if (videoBg) {
        videoBg.addEventListener("loadeddata", function (e) {
          // btnStart.click();

          // if(window.innerWidth > 992){
            console.log(videoBg);
            console.log('video paused:'+ videoBg.paused);
            if(videoBg.readyState >= 3) videoBg.play();
          // }
          // console.log(videoBg.readyState);
        });

        videoBg.addEventListener(
          "ended",
          function (e) {
            this.currentTime = 0;
            // this.load();
            this.play();
          },
          false
        );
      }
    });
  }
};

/* Animation reverse movie col content */

const reverseAnim = () => {
  const cols = document.querySelectorAll(".s-movies-cols__single-col");
  if (cols) {
    cols.forEach((el) => {
      el.addEventListener("mouseleave", (e) => {
        let tar = e.currentTarget;
        if (!tar.classList.contains("stop-anim")) {
          tar.classList.add("animation-reverse");
          cols.forEach((it) => {
            if (it != tar) it.classList.add("stop-anim");
          });
          setTimeout(() => {
            tar.classList.remove("animation-reverse");
            cols.forEach((it) => {
              if (it != tar) it.classList.remove("stop-anim");
            });
          }, 850);
        }
      });
    });
  }
};

/* Open/hide popap */

const popupAction = () => {
  const btnAction = document.querySelectorAll(".js-action-popup");
  const body = document.querySelector("body");

 
  //popups click
  let popupEventClick = (e,spec) => {
     e.preventDefault();

    //disable show popup for desktop
    if (
      e.target.classList.contains("js-mobile-click") &&
      window.innerWidth > 992
    )
      return;

    let specTarget = spec ? e.target.closest('.js-action-popup-render-ajax') : e.currentTarget;

    let target = specTarget.getAttribute("data-target");
    let imgPopChange = specTarget.getAttribute('data-setImage');
    let dataProperUser = specTarget.getAttribute('data-properUser');
    let dataProperRegister = specTarget.getAttribute('data-properRegister');
    let popup = document.getElementById(target);
    let onlyDesktop =
    specTarget.classList.contains("js-close-only-desktop") &&
      window.innerWidth < 992 ?
      false :
      true;
    const allPopups = document.querySelectorAll(".c-popup");
    
    //detect set active nav
    let switcherTarget = specTarget.getAttribute("data-switcherNavTarget");
    const allNavSwitcher = document.querySelectorAll('.js-switcher-content-nav');

    if(switcherTarget && allNavSwitcher){
      allNavSwitcher.forEach(bt =>{
        let btnTarget = bt.getAttribute("data-target");
        if(btnTarget == switcherTarget) bt.click();
      });
    }
    
    if (popup) {

      //set other image
      if(imgPopChange){
       let popCurentImg = popup.querySelector('.c-popup__img');
       let changedDataImage = JSON.parse(imgPopChange);
       if(changedDataImage.src) popCurentImg.setAttribute('src',changedDataImage.src);
       if(changedDataImage.srcset) popCurentImg.setAttribute('srcset',changedDataImage.srcset);
       if(changedDataImage.sizes) popCurentImg.setAttribute('sizes',changedDataImage.sizes);
      }

      //set special data exclusive obj
      const properPopupName = popup.querySelector('.js-data-exc-popup .js-proper-name');
      const properPopupCity = popup.querySelector('.js-data-exc-popup .js-proper-city');
      const properOverlayName = popup.querySelector('.js-property-inf-popup-image .js-proper-name');
      const properOverlayCity = popup.querySelector('.js-property-inf-popup-image .js-proper-city');
      const properOverlayArea = popup.querySelector('.js-property-inf-popup-image .js-proper-area');
      const properOverlayBedrooms = popup.querySelector('.js-property-inf-popup-image .js-proper-bedrooms');
      const properOverlayBtn = popup.querySelector('.c-popup__overlay-btn');

      const formExclusiveProperInput = popup.querySelector('form .js-set-property-input-data');
      const formExclusiveUserInput = popup.querySelector('form .js-set-user-input-data');
      const formPropertyName = popup.querySelector('form .js-additional-property-name');
      const formWrapper = popup.querySelector('.js-form-target');

      if(dataProperUser){
        const changedDataProperUser = JSON.parse(dataProperUser);
        if(properOverlayBtn) properOverlayBtn.classList.add('is-show');

        if(changedDataProperUser.properName){
          if(properPopupName) properPopupName.textContent = changedDataProperUser.properName;
          if(properOverlayName) properOverlayName.textContent = changedDataProperUser.properName;
        }

        if(changedDataProperUser.properCity) {
         if(properPopupCity) properPopupCity.textContent = changedDataProperUser.properCity;
         if(properOverlayCity) properOverlayCity.textContent = changedDataProperUser.properCity;
        }

        if(changedDataProperUser.properArea) properOverlayArea.innerHTML = changedDataProperUser.properArea;
        if(changedDataProperUser.properBedrooms) properOverlayBedrooms.textContent = changedDataProperUser.properBedrooms;
        
        //set form data
        if(formExclusiveProperInput){
          let propertyInf = '';
          if(changedDataProperUser.properFullName) propertyInf += 'Property name:'+ changedDataProperUser.properFullName +'</br>';
          if(changedDataProperUser.properCity) propertyInf += 'Property city:'+ changedDataProperUser.properCity +'</br>';
          if(changedDataProperUser.properId) propertyInf += 'Property ID:'+ changedDataProperUser.properId +'</br>';
          formExclusiveProperInput.value = propertyInf;
        }

        if(changedDataProperUser.properFullName){
          if(formPropertyName) formPropertyName.value = changedDataProperUser.properFullName;
        }

        if(formExclusiveUserInput){
          let userInf = '';
          if(changedDataProperUser.properName) userInf += 'User login:'+ changedDataProperUser.userLogin +'</br>';
          if(changedDataProperUser.userId) userInf += 'User ID:'+ changedDataProperUser.userId +'</br>';
          formExclusiveUserInput.value = userInf;
        }

      }
 
      //spec setting register popup
      const wrapRegisterData = popup.querySelector('.js-data-exc-register-popup');
      const properExInputName = popup.querySelector('#ex_proper_name');

      if(dataProperRegister){
        const changedDataProperRegister = JSON.parse(dataProperRegister);
        const properPopupRegName = popup.querySelector('.js-data-exc-register-popup .js-proper-name');
        const properPopupCity = popup.querySelector('.js-data-exc-register-popup .js-proper-city');

        if(changedDataProperRegister.properName && properPopupRegName) properPopupRegName.textContent = changedDataProperRegister.properName;
        if(changedDataProperRegister.properCity && properPopupCity) properPopupCity.textContent = changedDataProperRegister.properCity;

        if(wrapRegisterData) wrapRegisterData.classList.remove('c-popup__proper-exclusive-data--hidden');

        if(properExInputName && changedDataProperRegister.properFullName) properExInputName.value = changedDataProperRegister.properFullName;

      }else{
        if(wrapRegisterData){
          if(!wrapRegisterData.classList.contains('c-popup__proper-exclusive-data--hidden')){
            setTimeout(() => {
              wrapRegisterData.classList.add('c-popup__proper-exclusive-data--hidden');
            }, "1000");
         }

          if(properExInputName) properExInputName.value = '';
          
         }
      }

      //remove all data exclusive when close
      if(specTarget.classList.contains("js-close")){
        setTimeout(() => {
          if(properOverlayName) properOverlayName.textContent = '';
          if(properOverlayCity) properOverlayCity.textContent = '';
          if(properOverlayArea) properOverlayArea.textContent = '';
          if(properOverlayBedrooms) properOverlayBedrooms.textContent = '';
          if(properOverlayBtn) properOverlayBtn.classList.remove('is-show');
          if(properExInputName) properExInputName.value = '';
          if(formWrapper) formWrapper.classList.remove('succes-send');
        }, "1000");
      }

      if (specTarget.classList.contains("js-close-other-popap")) {
        allPopups.forEach((el) => {
          el.classList.remove("is-active");
          el.classList.remove("animation-start");
        });
      }

      if (specTarget.classList.contains("js-open")) {
        popup.classList.add("is-active");
        body.classList.add("popap-open");

        setTimeout(() => {
          popup.classList.add("animation-change");
        }, 100);

        // setTimeout(()=>{
        //   popup.classList.remove("animation-change");
        // },1500);

        if (specTarget.classList.contains("js-set-link")) {
          let slug = specTarget.getAttribute("data-slug");
          console.log(window.location.pathname);
          if (
            "/" + slug + "/" != window.location.pathname &&
            "/properties/" + slug != window.location.pathname
          ) {
            let url =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname;
            let fullUrl = specTarget.getAttribute("data-fullUrl");
            console.log(fullUrl);
            popup.classList.add("js-back-link");
            popup.setAttribute("data-backlink", url);
            let newurl = "";

            if (fullUrl) newurl = fullUrl;
            else newurl = url + slug;

            window.history.pushState({
                path: newurl,
              },
              "",
              newurl
            );
          }
        }
      } else {
        if (onlyDesktop) {
          popup.classList.add("animation-change-back");
          setTimeout(() => {
            popup.classList.remove("is-active");
            body.classList.remove("popap-open");
            popup.classList.remove("animation-change");
            popup.classList.remove("animation-change-back");
          }, 1050);

          if (popup.classList.contains("js-back-link")) {
            popup.classList.remove("js-back-link");
            let linkbasic = popup.getAttribute("data-backlink");
            window.history.pushState({
                path: linkbasic,
              },
              "",
              linkbasic
            );
          }
        }
      }
    }
  };

  btnAction.forEach((el) => {
    el.addEventListener("click", (e) => {
        popupEventClick(e,false); 
      });
  });

  //overlay close
  document.addEventListener(
    "click",
    function (e) {
      if (
        e.target.classList.contains("c-popup--version-2") ||
        e.target.classList.contains("c-popup__inner")
      ) {
        const allPopupsAtive = document.querySelectorAll(".c-popup.is-active");
        if (btnAction)
          btnAction.forEach((el) => el.classList.remove("is-active"));
        if (allPopupsAtive)
          allPopupsAtive.forEach((el) => {
            el.classList.remove("is-active");
            if (el.classList.contains("js-back-link")) {
              el.classList.remove("js-back-link");
              let linkbasic = el.getAttribute("data-backlink");
              window.history.pushState({
                  path: linkbasic,
                },
                "",
                linkbasic
              );
            }
          });
        body.classList.remove("popap-open");
      }

      //ajax open 
      if(e.target.closest('.js-action-popup-render-ajax')){
        popupEventClick(e,true);
      }
      
    },
    false
  );
};

/* Custom cursor */

const customCursor = function () {
  const body = document.querySelector("body");
  const cursor = document.querySelector(".js-cursor");
  body.addEventListener("mousemove", mouseMove);
  body.addEventListener("mouseover", mouseMove);

  function mouseMove(e) {
    cursor.style.left = e.clientX + "px";
    cursor.style.top = e.clientY + "px";
  }

  // let hovers = document.querySelectorAll("a,button ,.c-btn ,.js-hover-target");
  let hovers = document.querySelectorAll(".js-hover-target");

  hovers.forEach((el) => {
    let typeCursor = el.getAttribute("data-cursorType");
    el.addEventListener("mouseover", (e) => {
      cursor.classList.add("is-hover");
      if (typeCursor) cursor.classList.add(typeCursor);
    });

    el.addEventListener("mouseout", (e) => {
      cursor.classList.remove("is-hover");
      if (typeCursor) cursor.classList.remove(typeCursor);
    });
  });
};

const showTarget = () => {
  const btns = document.querySelectorAll(".js-show-target");
  if (btns) {
    btns.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.currentTarget.classList.add("hidden");
        const targetId = e.currentTarget.getAttribute("data-target");
        const targetEl = document.getElementById(targetId);
        if (targetEl) targetEl.classList.add("is-show");
      });
    });
  }
};

/* Set email member */
const setEmail = () => {
  const allForms = document.querySelectorAll(".js-set-email-member");
  if (allForms) {
    allForms.forEach((el) => {
      const emailTarget = el.getAttribute("data-email");
      const options = el.querySelectorAll(".js-member-email option");
      if (options) {
        options.forEach((opt) => {
          if (opt.value == emailTarget)
            opt.setAttribute("selected", "selected");
        });
      }
    });
  }
};

/* Set email member */
const setVacancies = () => {
  const allForms = document.querySelectorAll(".js-topic-set-input");
  if (allForms) {
    allForms.forEach((el) => {
      const topic = el.getAttribute("data-topic");
      const topicInput = el.querySelector(".js-set-topic");
      if (topicInput) topicInput.value = topic;
    });
  }
};

/* Form projects action */

const projectsFormAction = () => {
  const openProject = document.querySelector(".js-open-projects");
  if (openProject) {
    openProject.addEventListener("click", (e) =>
      e.currentTarget.closest("form").classList.toggle("open-project")
    );
  }

  //Mark projects
  const parent = document.querySelector(".js-set-form-project");
  if (parent) {
    const allProjects = parent.querySelectorAll(".js-single-project");
    const allInputs = parent.querySelectorAll(".js-change-topic-scroll input");

    const scrollHandler = () => {
      if (allProjects) {
        allProjects.forEach((el) => {
          var position = el.getBoundingClientRect();
          if (position.top < window.innerHeight && position.bottom >= 0) {
            const topic = el.getAttribute("data-topic");
            const checkedInput = parent.querySelector(
              ".js-change-topic-scroll input:checked"
            );
            if (checkedInput) {
              if (checkedInput.value != topic) {
                allInputs.forEach((input) => input.removeAttribute("checked"));
                allInputs.forEach((input) => {
                  if (input.value == topic) {
                    input.setAttribute("checked", "checked");
                    el.classList.add("is-topic-sett");
                  }
                });
              }
            }
          }
        });
      }
    };

    window.addEventListener("scroll", scrollHandler);
  }
  //hide show popup form
  const btnPopupForm = document.querySelectorAll(
    ".js-form-project-popup-action"
  );
  const targetForm = document.querySelector(".js-marker-project-form");

  if (btnPopupForm) {
    btnPopupForm.forEach((btn) => {
      btn.addEventListener("click", (e) =>
        targetForm.classList.toggle("is-show")
      );
    });
  }
};

/* Scroll to form after send */
const scrollForm = () => {
  document.addEventListener("wpcf7mailsent",function (event) {
      if (event.detail.contactFormId == 427) {
        console.log("weszlo");
        window.scrollTo(
          0,
          document.body.scrollHeight || document.documentElement.scrollHeight
        );
        window.scrollTo(0, document.querySelector(".c-footer").scrollHeight);
      }
    },
    false
  );
};

/* Specific class to animation box */
const movieImagesAnimation = () => {
  const linkBtn = document.querySelectorAll(".js-click-animation");
  if (linkBtn && window.innerWidth > 992) {
    linkBtn.forEach((it) => {
      it.addEventListener("click", (e) => {
        e.preventDefault();
        let linkPage = e.currentTarget.getAttribute("href");
        it.parentElement.classList.add("animated-box");
        setTimeout(function () {
          window.location.href = linkPage;
        }, 2250);
        setTimeout(function () {
          linkBtn.forEach((it) => {
            it.parentElement.classList.remove("animated-box");
          });
        }, 2450);
      });
    });
  }
};

const animationMoveLoad = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const myParam = urlParams.get("scr");
  const bodyElem = document.querySelector("body");
  const curtain = document.querySelectorAll(".s-simple-banner--curtain");
  if (myParam) {
    if (myParam == "curtain") {
      bodyElem.classList.add("animation-top");
      setTimeout(function () {
        if (curtain) curtain.forEach((el) => el.classList.add("disable"));
        bodyElem.classList.remove("animation-top");
      }, 1600);
    }
  }
};

/* Loader page */

// const loaderPage = (time) => {

//   function animateValue(obj, start, end, duration) {
//     let startTimestamp = null;
//     const step = (timestamp) => {
//       if (!startTimestamp) startTimestamp = timestamp;
//       const progress = Math.min((timestamp - startTimestamp) / duration, 1);
//       obj.innerHTML = Math.floor(progress * (end - start) + start);
//       if (progress < 1) window.requestAnimationFrame(step);
//     };
//     window.requestAnimationFrame(step);
//   }
//   const obj = document.getElementById("loader");
//   animateValue(obj, 0, 100, time);
// }

// //start loader
// loaderPage(12000);

/* Set specific elemen to full height */

const setFullHeight = () => {
  // const allElementFixed = document.querySelectorAll('.js-set-full-height');
  const allElementFixed = document.querySelectorAll('.snap-container , .js-set-full-height');
  if (allElementFixed) allElementFixed.forEach(el => el.style.height = window.innerHeight + "px");
  window.addEventListener('resize', () => {
    if (allElementFixed) allElementFixed.forEach(el => el.style.height = window.innerHeight + "px");
  });
}

const cookiesLoader = () => {
  /* Checked loaded page and hide loader */
  function getCookie(name) {
    let value = `; ${document.cookie}`;
    let parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  function createCookie(name, value, days) {
    var expires;

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }

    document.cookie = name + "=" + value + expires + "; path=/";
  }

  const loadingTemplate = document.querySelector(".c-loading-template");
  if (!getCookie("loader-status")) {
    if (loadingTemplate) {
      loadingTemplate.classList.add("animation-hide");
      setTimeout(function () {
        loadingTemplate.classList.add("hide-all");
      }, 200);
      // loadingTemplate.classList.add('hide-all');
      createCookie("loader-status", "loaded", 1);
    }
  }

  // console.log(getCookie('loader-status'));
};

window.onload = function () {
  cookiesLoader();
};

/* Change labels input newsletter */
const changeLabels = () => {
  const btnSubmit = document.querySelector(
    ".c-footer__newsletter.c-form-basic.newsletter-type .wpcf7-submit.c-btn"
  );
  if (btnSubmit && window.innerWidth < 992) btnSubmit.value = "SIGN UP";
};

/* Custom scroll indicator */
const customIndicatorScroll = () => {
  const elIndicat = document.querySelector(".js-custom-indicator");
  if (elIndicat) {
    elIndicat.addEventListener("scroll", (e) => {
      var winScroll = elIndicat.scrollLeft;
      var widthBar = (80 / document.documentElement.clientWidth) * 100;
      var width = elIndicat.scrollWidth - document.documentElement.clientWidth;
      var scrolled = (winScroll / width) * (100 - widthBar);
      document.getElementById("myBar").style.left = scrolled + "%";
    });
  }
};

/*Marquee custom animation */
const marqueCustom = () => {
  var marqueePosition = 100;
  var speed = 10; //smaller number means faster movement
  var e = document.querySelector(".js-marquee .s-simple-banner__marquee-wrap");
  if (e) {
    function moveMarquee() {
      // marqueePosition--;
      marqueePosition = marqueePosition - 6;
      if (marqueePosition < -1 * e.offsetWidth)
        marqueePosition = (1 * e.offsetWidth) / 1.4;
      e.style["-webkit-transform"] =
        "translate(" + marqueePosition + "px, 0px)";
      e.style["-moz-transform"] = "translate(" + marqueePosition + "px, 0px)";
      e.style["-ms-transform"] = "translate(" + marqueePosition + "px, 0px)";
      e.style["-o-transform"] = "translate(" + marqueePosition + "px, 0px)";
      e.style["transform"] = "translate(" + marqueePosition + "px, 0px)";
      window.setTimeout(function () {
        requestAnimationFrame(moveMarquee);
      }, speed);
    }
    moveMarquee();
  }
};

const fullPageScroll = () => {
  const container = document.querySelector(".snap-container");
  const btnBackTop = document.querySelector('.js-back-top-page');

  // if (container) {
  //   container.addEventListener("scroll", (e) => {
  //     const getFirstSection = container.firstElementChild;
  //     const header = document.querySelector(".c-header");
  //     let distance = -150;
  //     if (getFirstSection) {
  //       if (getFirstSection.getBoundingClientRect().top < distance && !header.classList.contains('header-hidden')) {
  //         header.classList.add("header-hidden");
  //       } else if (getFirstSection.getBoundingClientRect().top > distance && header.classList.contains('header-hidden')) {
  //         header.classList.remove("header-hidden");
  //       }
  //     }

  //     //show back top btn

  //     if (getFirstSection.getBoundingClientRect().top <= -(window.innerHeight/2) && !btnBackTop.classList.contains('show-anim')) {
  //       btnBackTop.classList.add('show-anim');
  //     } else if (getFirstSection.getBoundingClientRect().top >= -(window.innerHeight/2)) {
  //       btnBackTop.classList.remove('show-anim');
  //     }
  //     // if (!getFirstSection.classList.contains("active")) {
  //     //   header.classList.add("header-hidden");
  //     // } else {
  //     //   header.classList.remove("header-hidden");
  //     // }
  //   });
  // }

  //back top
  // if (btnBackTop) {
  //   btnBackTop.addEventListener('click', function (e) {
  //     e.preventDefault();
  //     container.scrollTo({
  //       top: 0,
  //       left: 0,
  //       behavior: "smooth",
  //     });
  //   });
  // }
};

const backProperLink = () =>{
  const backLink = document.querySelector('.js-back-proper-link');
  if(backLink) backLink.addEventListener('click', () => window.history.back());
}

/* Custom show hide message */

const showCustomMessageCf7 = () => {
  document.addEventListener("wpcf7mailsent",(e) => {

    let targetEl = e.target.closest('.js-form-target');
    if(targetEl) targetEl.classList.add('succes-send');

    const detectPopupForm = document.querySelectorAll('.c-popup.is-active');

    /* Add tracking GTM -4 */

    window.dataLayer = window.dataLayer || [];
    const parentCheckProperty = e.target.closest('.c-form-basic');

    /* Comment event tracking */

    if(parentCheckProperty){
      const dataEventProper = parentCheckProperty.getAttribute('data-formcustom');

      if(dataEventProper){
        const parseData = JSON.parse(dataEventProper);
        window.dataLayer.push(parseData);
      }else{
        window.dataLayer.push(
          {
            'event': 'formSubmission',
            'pageLink': window.location.href,
            'formVariant': 'Global Form',
          }
        );
      }
    }

    /* Add tracking fb */

    if(detectPopupForm && typeof fbq === 'function'){
      detectPopupForm.forEach(pop => {
        if(pop.id === 'contact-page-popup') fbq('track', 'Contact');
        else if(pop.id === 'contact-propertie-popup') fbq('track', 'Lead');
      });
    }

  },false);
}


// event google tracking

const customTrackingEventsProperty = () => {

  const body = document.querySelector('body'); 

  if(body){
    const dataEventProper = body.getAttribute('data-propertie');
    /* Comment event tracking */
    if(dataEventProper){
      window.dataLayer = window.dataLayer || [];
      const parseData = JSON.parse(dataEventProper);
      window.dataLayer.push(parseData);
    }

  }

}

const customClickEvent = () => {

  const allSimpleEvents = document.querySelectorAll('.js-customs-events-google');

  if(allSimpleEvents){

    allSimpleEvents.forEach(el =>{

      el.addEventListener('click',(e) => {

        const dataEventClick = e.currentTarget.getAttribute('data-eventsclick');
    /* Comment event tracking */
        if(dataEventClick){
          window.dataLayer = window.dataLayer || [];
          const parseData = JSON.parse(dataEventClick);
          window.dataLayer.push(parseData);
          //console.log(dataEventClick);
        }

      });

    })
  }

}


const init = () => {
  menu();
  playVideo();
  popupAction();
  customCursor();
  showTarget();
  setEmail();
  setVacancies();
  projectsFormAction();
  // reverseAnim();
  setFullHeight();
  movieImagesAnimation();
  changeLabels();
  customIndicatorScroll();
  marqueCustom();
  // scrollForm();
  // animationMoveLoad();
  // cookiesLoader();
  fullPageScroll();
  backProperLink();
  showCustomMessageCf7();
  customTrackingEventsProperty();
  customClickEvent();

  if (typeof AOS !== "undefined")
    AOS.init({
      duration : 1500,
      // disable: "mobile",
    });
};

window.addEventListener("load", (event) => {
  const loadingTemplate = document.querySelector(".js-loader-all-media");
  if (loadingTemplate) {
    loadingTemplate.classList.add("animation-hide");
    setTimeout(function () {
      loadingTemplate.classList.add("hide-all");
      loadingTemplate.style.display = 'none';
    }, 700);
  }

  animationMoveLoad();
});

document.addEventListener("DOMContentLoaded", () => {
  init();
  const header = document.querySelector(".c-header");
  if (header) header.classList.remove("header-hidden", "small-delay");

  document.addEventListener('scroll', (event) => { const aosAnimation = document.querySelectorAll('[data-aos]');
  observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
    if (entry.intersectionRatio > 0) entry.target.classList.add('aos-animate');
    else entry.target.classList.remove('aos-animate');
    });
  });
  aosAnimation.forEach(aosObject => {
  observer.observe(aosObject);
  });}, {capture: true, passive: true,})

  // setTimeout(function () {
  //   var t = performance.timing;
  //   let EstimatedTime =  t.domContentLoadedEventEnd - t.domContentLoadedEventStart;
  //   console.log(EstimatedTime);
  //   loaderPage(6000);
  // }, 10);
});